module.exports = __webpack_public_path__ + "static/img/方便的力学换算式.ff92e54d.jpg";